"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AppNavContext", {
  enumerable: true,
  get: function get() {
    return _context["default"];
  }
});
Object.defineProperty(exports, "withAppNavContext", {
  enumerable: true,
  get: function get() {
    return _withAppNavContext["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Badge = _interopRequireDefault(require("../Badge"));

var _Container = _interopRequireDefault(require("../Container"));

var _DataSwitch = _interopRequireDefault(require("../DataSwitch"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _Row = _interopRequireDefault(require("../Row"));

var _Toggle = _interopRequireDefault(require("../Toggle"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

require("./styles.css");

var _context = _interopRequireDefault(require("./context"));

var _withAppNavContext = _interopRequireDefault(require("./withAppNavContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AppNav =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AppNav, _PureComponent);

  function AppNav(_props) {
    var _this;

    _classCallCheck(this, AppNav);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppNav).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "setComponentState", function (state) {
      return new Promise(function (resolve) {
        return _this.setState(state, resolve);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateData", function (dataFn) {
      var propsData = _this.props.data;
      var stateData = _this.state.data;

      if (dataFn) {
        if ((0, _lib.isArray)(dataFn)) {
          _this.setState({
            data: dataFn
          });
        } else if ((0, _lib.isFunc)(dataFn)) {
          var data = dataFn(propsData, stateData);

          if (data) {
            _this.setState({
              data: data
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderPrimaryAppNav", function (toggleProps) {
      var _this$props = _this.props,
          bottomNode = _this$props.bottomNode,
          onMenuClick = _this$props.onMenuClick;
      var Wrapper = (0, _lib.getElementType)(_assertThisInitialized(_this), _this.props);

      var classNames = _this.classNames(AppNav.primaryClassName);

      return _react["default"].createElement(Wrapper, {
        className: classNames
      }, _react["default"].createElement(_DataSwitch["default"].Consumer, null, function (_ref) {
        var data = _ref.data,
            _onChange = _ref.onChange,
            value = _ref.value;
        return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Menu["default"], {
          data: data,
          value: value,
          onChange: function onChange(e, v) {
            return _onChange(e, {
              value: v
            });
          },
          activeCondition: function activeCondition(_ref2) {
            var item = _ref2.item,
                v = _ref2.value;
            return _this.isSelected({
              data: item,
              keySelector: 'value',
              value: v
            });
          },
          itemNode: _this.renderPrimaryAppNavList
        }), (0, _lib.getRenderProps)(bottomNode, _objectSpread({
          onMenuClick: onMenuClick,
          visible: toggleProps.active
        }, toggleProps)));
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPrimaryAppNavList", function (item, idx, props) {
      var value = item.value,
          disabled = item.disabled,
          tooltip = item.tooltip,
          title = item.title,
          icon = item.icon,
          data = item.data,
          itemRest = _objectWithoutProperties(item, ["value", "disabled", "tooltip", "title", "icon", "data"]);

      var menu = _react["default"].createElement(_Menu["default"].Item, _extends({
        key: value || idx
      }, itemRest, props), (0, _lib.isString)(icon) ? _react["default"].createElement(_Icon["default"], {
        color: "white",
        name: icon,
        style: {
          fontSize: '1.5rem'
        }
      }) : icon || title.charAt(0));

      if (tooltip) {
        return _react["default"].createElement(_Tooltip["default"], {
          key: value || idx,
          disabled: disabled,
          content: tooltip,
          direction: "right",
          trigger: "hover"
        }, menu);
      }

      return menu;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSecondaryAppNav", function (toggleProps) {
      var Wrapper = (0, _lib.getElementType)(_assertThisInitialized(_this), _this.props, 'asSecondary');

      var classNames = _this.classNames(AppNav.secondaryClassName, toggleProps);

      return _react["default"].createElement(Wrapper, {
        className: classNames,
        noContent: Wrapper === _Container["default"] ? true : null
      }, _react["default"].createElement(_DataSwitch["default"].Consumer, null, function (_ref3) {
        var selected = _ref3.selected,
            _onChange2 = _ref3.onChange,
            value = _ref3.value;
        return _react["default"].createElement(_Menu["default"], {
          data: selected ? selected.data : [],
          disabled: selected ? !selected.data : false,
          onChange: function onChange(e, v) {
            return _onChange2(e, {
              value: v
            });
          },
          activeCondition: function activeCondition(_ref4) {
            var item = _ref4.item;
            return value ? value === item.value : false;
          },
          itemNode: function itemNode(item, idx, props) {
            return _this.renderSecondaryAppNavList(value, item, idx, props);
          }
        });
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSecondaryAppNavList", function (currentValue, item, idx, _ref5) {
      var onClick = _ref5.onClick,
          propsRest = _objectWithoutProperties(_ref5, ["onClick"]);

      var value = item.value,
          isHeader = item.isHeader,
          title = item.title,
          rest = _objectWithoutProperties(item, ["value", "isHeader", "title"]);

      return _react["default"].createElement(_Menu["default"].Item, _extends({
        key: value || idx,
        value: currentValue,
        textAlign: "left",
        isHeader: isHeader,
        onClick: !isHeader ? onClick : null
      }, rest, propsRest), title);
    });

    _defineProperty(_assertThisInitialized(_this), "renderToggleButton", function (_ref6) {
      var toggle = _ref6.toggle,
          active = _ref6.active;

      var classNames = _this.classNames(AppNav.buttonClassName, {
        active: active
      });

      return _react["default"].createElement(_Badge["default"], {
        className: classNames,
        outline: true,
        onClick: toggle,
        content: active ? _react["default"].createElement(_Icon["default"].Back, null) : _react["default"].createElement(_Icon["default"].Menu, null)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isSelected", function (_ref7) {
      var data = _ref7.data,
          keySelector = _ref7.keySelector,
          value = _ref7.value;

      if (value && (0, _lib.isString)(value)) {
        var itemValue = (0, _lib.getSelectorValue)(data, keySelector);
        var paths = value.split('/').filter(function (s) {
          return s;
        });

        if ((0, _lib.arrayHasItems)(paths)) {
          return itemValue.startsWith("/".concat(paths[0]));
        }

        return itemValue === '/';
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isVisible", function (_ref8) {
      var selected = _ref8.selected;
      var visible = _this.props.visible;

      if (selected) {
        return (0, _lib.objHasOwnProperty)(selected, 'data') && !!selected.data;
      }

      return visible;
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AppNav.primaryClassName;
      var toggleProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var names = [name];
      (0, _lib.addClassByPropName)(names, {
        visible: toggleProps.active
      }, ['visible']);

      if (toggleProps.active) {
        document.body.classList.add(AppNav.appNavVisibleClassName);
      } else {
        document.body.classList.remove(AppNav.appNavVisibleClassName);
      }

      return names.join(' ');
    });

    var _data = _props.data;
    _this.state = {
      prevProps: {
        data: _data
      },
      data: _data
    };
    return _this;
  }

  _createClass(AppNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          oriData = _this$props2.data,
          onChange = _this$props2.onChange,
          onOpen = _this$props2.onOpen,
          onClose = _this$props2.onClose,
          onToggle = _this$props2.onToggle,
          value = _this$props2.value;
      var data = this.state.data;
      return _react["default"].createElement(_DataSwitch["default"], {
        data: data,
        value: value,
        onChange: onChange,
        selectedCondition: this.isSelected
      }, function (dataSwitchProps) {
        var visible = _this2.isVisible(dataSwitchProps);

        return _react["default"].createElement(_Toggle["default"], {
          active: visible,
          onToggleOn: onOpen,
          onToggleOff: onClose,
          onToggle: onToggle
        }, function (toggleProps) {
          var context = {
            data: data,
            oriData: oriData,
            visible: toggleProps.active,
            contentClassName: _this2.classNames(AppNav.contentClassName, toggleProps),
            setContext: _this2.setComponentState,
            updateData: _this2.updateData
          };
          return _react["default"].createElement(_context["default"].Provider, {
            value: context
          }, _this2.renderPrimaryAppNav(toggleProps), _this2.renderSecondaryAppNav(toggleProps), _this2.renderToggleButton(toggleProps), (0, _lib.getRenderProps)(children, context));
        });
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var data = props.data;
      return {
        // Store the previous props in state
        prevProps: {
          data: data
        },
        data: prevProps.data !== data ? data : state.data
      };
    }
  }]);

  return AppNav;
}(_react.PureComponent);

exports["default"] = AppNav;

_defineProperty(AppNav, "Consumer", _context["default"].Consumer);

_defineProperty(AppNav, "primaryClassName", 'MHub-AppNav-Primary');

_defineProperty(AppNav, "secondaryClassName", 'MHub-AppNav-Secondary');

_defineProperty(AppNav, "contentClassName", 'MHub-AppNav-Content');

_defineProperty(AppNav, "buttonClassName", 'MHub-AppNav-Button');

_defineProperty(AppNav, "appNavVisibleClassName", 'MHub-AppNav-Visible');

_defineProperty(AppNav, "propTypes", {
  as: _common.customPropTypes.as,
  asSecondary: _common.customPropTypes.as,
  children: _common.customPropTypes.render.isRequired,
  bottomNode: _common.customPropTypes.render,
  data: _common.customPropTypes.appNavData,
  value: _propTypes["default"].string,
  visible: _propTypes["default"].bool,
  onMenuClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onToggle: _propTypes["default"].func
});

_defineProperty(AppNav, "defaultProps", {
  as: _Row["default"],
  asSecondary: _Container["default"],
  bottomNode: function bottomNode(_ref9) {
    var onMenuClick = _ref9.onMenuClick;
    return _react["default"].createElement(_Menu["default"], {
      as: _Row["default"],
      end: true,
      data: [{
        // TODO: Update icon.
        icon: _react["default"].createElement(_Icon["default"].Menu, {
          style: {
            fontSize: '1.5rem'
          }
        }),
        onClick: onMenuClick,
        active: false,
        value: 'menu'
      }],
      itemNode: function itemNode(_ref10, idx, props) {
        var value = _ref10.value,
            icon = _ref10.icon,
            rest = _objectWithoutProperties(_ref10, ["value", "icon"]);

        return _react["default"].createElement(_Menu["default"].Item, _extends({
          key: value
        }, props, rest), icon);
      }
    });
  },
  data: [],
  value: null,
  visible: true,
  onMenuClick: function onMenuClick() {},
  onChange: function onChange() {},
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onToggle: function onToggle() {}
});